module.exports = __webpack_public_path__ + "static/media/title_3.66d40e84.svg";